import type { FormInputType } from '@/components/UI/Form/types'

export default function getAddUserStoryFormInputs(): FormInputType[] {
  return [
    {
      label: 'What is the title of your story?',
      type: 'text',
      name: 'title',
      required: true,
      size: 6,
    },
    {
      label: 'Please share your schoolhouse story below:',
      type: 'textarea',
      name: 'body',
      required: true,
      size: 6,
    },
    {
      label: 'Are you sharing this story as a learner or tutor?',
      type: 'select',
      name: 'role',
      options: [
        {
          value: 'learner',
          label: 'Learner',
        },
        {
          value: 'tutor',
          label: 'Tutor',
        },
      ],
      required: true,
      size: 6,
    },
    {
      type: 'multi-checkbox',
      name: 'terms',
      label: 'Please acknowledge that, if accepted, you agree to have your story shared publicly.',
      sublabel:
        'Your first name, last initial, profile picture, and country will be shared along with your story. Schoolhouse.world may also use these stories in other areas of the website and as promotional material.',
      options: [
        {
          value: 'acceptedTerms',
          label: 'I accept',
        },
      ],
      required: true,
      size: 6,
    },
  ]
}
